import {Component, Input} from '@angular/core';

@Component({
  selector: 'app-icon-location-add',
  imports: [],
  templateUrl: './icon-location-add.component.html',
})
export class IconLocationAddComponent {
  @Input() color: string = '#E41B2E';
  @Input() width: string = '18px';
  @Input() height: string = '18px';
}
